import { FileDownIcon, FileTextIcon } from 'lucide-react';
import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';

type EvidenceCardProps = {
  fileName: string;
  documentId: string;
  onViewEvidence: (documentId: string) => void;
  onDownloadEvidence: (documentId: string) => void;
};

export const EvidenceCard = ({ fileName, documentId, onViewEvidence, onDownloadEvidence }: EvidenceCardProps) => {
  return (
    <>
      <Inline
        align="center"
        className="w-full rounded-lg bg-seapoint-gray-background-select-item px-5 py-6"
        justify="between"
      >
        <Inline space={3}>
          <FileTextIcon className="h-6 w-6" strokeWidth={1} />
          <button
            className="text-sm font-normal text-seapoint-blue-link hover:underline"
            onClick={() => onViewEvidence(documentId)}
          >
            {fileName}
          </button>
        </Inline>
        <Button onClick={() => onDownloadEvidence(documentId)} variant="ghost" aria-label="Download Evidence">
          <FileDownIcon className="h-6 w-6 text-seapoint-gray-text" strokeWidth={1} />
        </Button>
      </Inline>
    </>
  );
};
